import { Component, OnInit, ViewChildren } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

import { ReplyTemplateService } from 'src/sb-modules/Frontend-Reply-Templates-Module/core/reply-template.service';
import { CommonDataService } from '@sb-tools/typescript/services/common-data.service';
import { HelperService } from '@sb-tools/typescript/services/helper.service';
import { TextVariableService } from '@sb-tools/typescript/services/text-variable.service';
import { ReplyTemplate } from '@sb-tools/typescript/models/reply-template.model';
import { InboxAttachmentBase } from '@sb-tools/typescript/models/inbox-attachment-base.model';
import { UserRole } from '@sb-tools/typescript/enums/user-role.enum';

import { ReplyTemplatesListComponent } from './reply-templates-list/reply-templates-list.component';
import { TemplateEntity } from './core/template-entity.model';
import { environment } from '@environment';
import { InlineSVGComponent } from '../Frontend-Inline-SVG-Module/inline-svg.component';
import { TranslateModule } from '@ngx-translate/core';
import { LoaderComponent } from '@sb-tools/typescript/components/loader/loader.component';
import { FormsModule } from '@angular/forms';
import { FocusDirective } from '@sb-tools/typescript/directives/focus.directive';
import { QuillModule } from 'ngx-quill';

@Component({
    selector: 'sb-reply-templates-modal',
    templateUrl: './reply-templates-modal.component.html',
    styleUrls: ['./reply-templates-modal.component.scss'],
    imports: [
        InlineSVGComponent,
        TranslateModule,
        LoaderComponent,
        ReplyTemplatesListComponent,
        FormsModule,
        FocusDirective,
        QuillModule,
    ],
})
export class ReplyTemplatesModalComponent implements OnInit {
    @ViewChildren(ReplyTemplatesListComponent) replyTemplatesLists: ReplyTemplatesListComponent[];

    confirmCallback;
    currentFolderName = '';
    environment = environment;
    filteredTemplates: TemplateEntity[] = [];
    hasBackButton = true;
    isAdmin: boolean;
    isTextContent = true;
    isVariablesView = false;
    keyword = '';
    modalId? = null; // if modal is nested, need to pass id to close particular this modal
    quillConfig = {
        toolbar: false,
    };
    replyTemplate: ReplyTemplate;
    textWithVariables: string;
    variableValues: any = {};
    variables;
    selectedTemplate: TemplateEntity;

    constructor(
        public replyTemplateService: ReplyTemplateService,
        public commonDataService: CommonDataService,
        private modalRef: BsModalRef,
        private modalService: BsModalService,
        private textVariableService: TextVariableService,
    ) {}

    ngOnInit(): void {
        this.isAdmin = this.commonDataService.user.role === UserRole.admin;
    }

    add(text: string, attachments: InboxAttachmentBase[]): void {
        this.confirmCallback(text, structuredClone(attachments));
        this.close();
    }

    back(): void {
        this.isVariablesView = false;
    }

    chooseTemplate(template: TemplateEntity): void {
        const selectedTemplatedText = this.isTextContent ? HelperService.strip(template.text, false) : template.text;

        this.variables = this.textVariableService.getVariables(selectedTemplatedText);

        if (this.variables.length > 0) {
            this.variableValues = {};
            this.isVariablesView = true;
            this.selectedTemplate = template;
            this.textWithVariables = selectedTemplatedText;
        } else {
            this.add(selectedTemplatedText, template.attachments);
        }
    }

    close(): void {
        if (this.modalId) {
            this.modalService.hide(this.modalId);
        } else {
            this.modalRef.hide();
        }
    }

    startTextSearch(): void {
        this.replyTemplatesLists.forEach((replyTemplateList) => {
            replyTemplateList.filterReplyTemplatesByKeyword(this.keyword);
        });
    }

    updateTemplateText(): void {
        this.textWithVariables = this.isTextContent
            ? HelperService.strip(this.selectedTemplate.text, false)
            : this.selectedTemplate.text;
        this.variables.forEach((variable) => {
            const variableScreened = variable.replace(/\{/g, '\\{').replace(/\}/g, '\\}');
            if (this.variableValues[variable]) {
                this.textWithVariables = this.textWithVariables.replace(
                    RegExp(variableScreened, 'g'),
                    this.variableValues[variable],
                );
            }
        });
    }

    protected readonly structuredClone = structuredClone;
}
